<template>
  <div class="watch-now">
    <div class="home__section container">
      <div class="home__header home__header--white">
        <h1>{{ $t('headers.watch-now') }}</h1>
        <hr class="divider">
      </div>
      <lazy-component
        v-if="video"
        class="watch-now__video"
        :style="{ 'background-image': `linear-gradient(rgba(0,0,0,0.5), rgba(0, 0, 0, 0.5)), url(${video.homePageImage})` }"
      >
        <a
          v-if="!$isMobile"
          class="watch-now__button"
          :href="video.url"
        >
          <span class="watch-now__button-triangle" />
        </a>
        <div class="watch-now__content">
          <h2 class="watch-now__title">{{ video.title }}</h2>
          <a class="watch-now__link" :href="video.url">{{ $t("buttons.watch-now") }}</a>
        </div>
      </lazy-component>
      <div v-if="videoArticles.length > 1" class="watch-now__videos">
        <lazy-component
          v-for="(videoArticle,index) in videoArticles.slice(1)"
          :key="index"
          class="video-block"
        >
          <img
            class="video-block__image"
            :src="videoArticle.thumbnail"
          >
          <h3 class="video-block__title">
            {{ videoArticle.title }}
          </h3>
          <div class="video-block__footer">
            <a class="video-block__link" :href="videoArticle.url">{{ $t("buttons.watch-now") }}</a>
            <div class="video-block__spins">
              <label>SPINS</label>
              <i class="bandwagon-logo bandwagon-logo--arc" />
              <label class="video-block__spins-number">{{ videoArticle.spins }}</label>
            </div>
          </div>
        </lazy-component>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag';

export default {
  props: {
    locale: {
      type: String,
      default: 'en',
    },
    country: {
      type: String,
      default: 'SG',
    },
    cache: {
      type: Object,
      default: () => ({
        cache: true,
        component: 'watch_now'
      })
    }
  },
  apollo: {
    videoArticles: {
      query: gql`
        query getVideos($locale: String!, $country: String!){
          featuredArticles(type: "video", country: $country, locale: $locale, limit: 4) {
            image thumbnail title url spins homePageImage
          }
        }`,
      variables() {
        return {
          country: this.country,
          locale: this.locale,
          cache:this.cache
        };
      },
      update(data) {
        return data.featuredArticles;
      },
    },
  },
  data() {
    return {
      videoArticles: [],
      cursor: null,
    };
  },
  computed: {
    video() {
      return this.videoArticles ? this.videoArticles[0] : null;
    },
  },
};
</script>
